/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Notes_PlaceholderInputs */

const en_search_notes_placeholder = /** @type {(inputs: Search_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search notes...`)
};

const es_search_notes_placeholder = /** @type {(inputs: Search_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar notas...`)
};

/**
* | output |
* | --- |
* | "Search notes..." |
*
* @param {Search_Notes_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_notes_placeholder = /** @type {((inputs?: Search_Notes_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Notes_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_notes_placeholder(inputs)
	return es_search_notes_placeholder(inputs)
});